import React from 'react';

/**
 * WCAG 2.4.1 — bypass repeated navigation. Visible on keyboard focus only.
 */
const SkipToMainLink: React.FC = () => (
  <a href="#main-content" className="skip-to-main">
    Skip to main content
  </a>
);

export default SkipToMainLink;
